// import React from "react";
// import "./flights-content.scss";
// import { Link } from "react-router-dom";

// const FlightsContent = ({ onToggle, flights }) => {
//   return (
//     <>
//       <div className="flights-content">
//         <div className="heading-wrap">
//           <h2>801 Flights found</h2>
//           <div className="select-sort-by">
//             <select name="sort_by" id="sort-by">
//               <option value="recommended">Sort by: Recommended</option>
//               <option value="recommended">Low to High</option>
//               <option value="recommended">High to Low</option>
//               <option value="recommended">Latest</option>
//             </select>
//           </div>
//           <button id="toggle_hide" onClick={onToggle}>
//             <img src="/images/icons/sort.svg" alt="filters" />
//           </button>
//         </div>

//         <div className="flight-item-box">
//           <div className="badges">
//             <div className="badge-cheap">Cheapest</div>
//             <div className="badge-light">
//               {" "}
//               <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
//               included
//             </div>
//           </div>
//           <div className="row justify-content-between align-items-center">
//             <div className="col-md-3 py-0">
//               <div className="air-line">
//                 <img src="/images/icons/emirates.svg" alt="airline" />
//                 <p>Emirates, A380</p>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="flight-row">
//                 <div className="title">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//                 <div className="time-duration">
//                   <p>8h 50m</p>
//                   <img src="/images/icons/flight-row.svg" alt="flight-row" />
//                   <p>5h in Karachi</p>
//                 </div>
//                 <div className="title to">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="price-wrap">
//                 <div className="price">
//                   <h2>Rs 102,850</h2>
//                   <p>Return</p>
//                 </div>
//                 <Link to="/flight-checkout" className="flight-select">
//                   Select
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flight-item-box">
//           <div className="badges">
//             <div className="badge-cheap">Cheapest</div>
//             <div className="badge-light">
//               {" "}
//               <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
//               included
//             </div>
//           </div>
//           <div className="row justify-content-between align-items-center">
//             <div className="col-md-3 py-0">
//               <div className="air-line">
//                 <img src="/images/icons/emirates.svg" alt="airline" />
//                 <p>Emirates, A380</p>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="flight-row">
//                 <div className="title">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//                 <div className="time-duration">
//                   <p>8h 50m</p>
//                   <img src="/images/icons/flight-row.svg" alt="flight-row" />
//                   <p>5h in Karachi</p>
//                 </div>
//                 <div className="title to">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="price-wrap">
//                 <div className="price">
//                   <h2>Rs 102,850</h2>
//                   <p>Return</p>
//                 </div>
//                 <Link to="/flight-checkout" className="flight-select">
//                   Select
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flight-item-box">
//           <div className="badges">
//             <div className="badge-cheap">Cheapest</div>
//             <div className="badge-light">
//               {" "}
//               <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
//               included
//             </div>
//           </div>
//           <div className="row justify-content-between align-items-center">
//             <div className="col-md-3 py-0">
//               <div className="air-line">
//                 <img src="/images/icons/emirates.svg" alt="airline" />
//                 <p>Emirates, A380</p>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="flight-row">
//                 <div className="title">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//                 <div className="time-duration">
//                   <p>8h 50m</p>
//                   <img src="/images/icons/flight-row.svg" alt="flight-row" />
//                   <p>5h in Karachi</p>
//                 </div>
//                 <div className="title to">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="price-wrap">
//                 <div className="price">
//                   <h2>Rs 102,850</h2>
//                   <p>Return</p>
//                 </div>
//                 <Link to="/flight-checkout" className="flight-select">
//                   Select
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flight-item-box">
//           <div className="badges">
//             <div className="badge-cheap">Cheapest</div>
//             <div className="badge-light">
//               {" "}
//               <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
//               included
//             </div>
//           </div>
//           <div className="row justify-content-between align-items-center">
//             <div className="col-md-3 py-0">
//               <div className="air-line">
//                 <img src="/images/icons/emirates.svg" alt="airline" />
//                 <p>Emirates, A380</p>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="flight-row">
//                 <div className="title">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//                 <div className="time-duration">
//                   <p>8h 50m</p>
//                   <img src="/images/icons/flight-row.svg" alt="flight-row" />
//                   <p>5h in Karachi</p>
//                 </div>
//                 <div className="title to">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="price-wrap">
//                 <div className="price">
//                   <h2>Rs 102,850</h2>
//                   <p>Return</p>
//                 </div>
//                 <Link to="/flight-checkout" className="flight-select">
//                   Select
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flight-item-box">
//           <div className="badges">
//             <div className="badge-cheap">Cheapest</div>
//             <div className="badge-light">
//               {" "}
//               <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
//               included
//             </div>
//           </div>
//           <div className="row justify-content-between align-items-center">
//             <div className="col-md-3 py-0">
//               <div className="air-line">
//                 <img src="/images/icons/emirates.svg" alt="airline" />
//                 <p>Emirates, A380</p>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="flight-row">
//                 <div className="title">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//                 <div className="time-duration">
//                   <p>8h 50m</p>
//                   <img src="/images/icons/flight-row.svg" alt="flight-row" />
//                   <p>5h in Karachi</p>
//                 </div>
//                 <div className="title to">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="price-wrap">
//                 <div className="price">
//                   <h2>Rs 102,850</h2>
//                   <p>Return</p>
//                 </div>
//                 <Link to="/flight-checkout" className="flight-select">
//                   Select
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flight-item-box">
//           <div className="badges">
//             <div className="badge-cheap">Cheapest</div>
//             <div className="badge-light">
//               {" "}
//               <img src="/images/icons/carry.svg" alt="icon" /> Carry-on baggage
//               included
//             </div>
//           </div>
//           <div className="row justify-content-between align-items-center">
//             <div className="col-md-3 py-0">
//               <div className="air-line">
//                 <img src="/images/icons/emirates.svg" alt="airline" />
//                 <p>Emirates, A380</p>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="flight-row">
//                 <div className="title">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//                 <div className="time-duration">
//                   <p>8h 50m</p>
//                   <img src="/images/icons/flight-row.svg" alt="flight-row" />
//                   <p>5h in Karachi</p>
//                 </div>
//                 <div className="title to">
//                   <h5>13:30</h5>
//                   <p>LHR</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 py-0">
//               <div className="price-wrap">
//                 <div className="price">
//                   <h2>Rs 102,850</h2>
//                   <p>Return</p>
//                 </div>
//                 <Link to="/flight-checkout" className="flight-select">
//                   Select
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FlightsContent;
import React from "react";
import "./flights-content.scss";
import { Link } from "react-router-dom";
import { requestFlightsPreorder } from "../../../requests/flightsAPI";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import {post} from '../../../utils/request';
import {buildFlightsUrl} from "../Flights";
import {Tooltip} from 'antd';


const FlightsContent = ({
  isLoading,
  onToggle,
  flights,
  passenger,
  flightSearchParams,
  flightSearchResult,
  sortBy,
  flightsLocationSelections
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const locationSelections = location?.state?.locationSelections;

  const fromFlight = (flightOffer) => {
    let flights = flightOffer.flights.map((flight) => {
      return {
        flightNumber: flight.flightNumber,
        airlineIata: flight.airline?.iata,
        cabinClass: flight.cabinClass,
        classOfService: flight.classOfService,
        departureAirport: flight.departure?.airport,
        departureDateTime: flight.departure?.dateTime,
        arrivalAirport: flight.arrival?.airport,
        arrivalDatetime: flight.arrival?.dateTime,
        baggage: flight.baggage,
        freeServices: flight.freeServices,
        seatsAvailable: flight.seatsAvailable,
      };
    });

    return {
      currency: flightOffer.price?.currency,
      flights: flights,
      traceId: flightOffer?.traceId,
      serverData: flightOffer?.serverData,
    };
  };

  function formatTime(departDateTime) {
    if (!departDateTime) {
      return "";
    }

    return departDateTime.substring(11, 16);
  }

  function formatDuration(duration) {
    const total = Math.floor(Number(duration) || 0);
    const hh = Math.floor(total / 60);
    const mm = total % 60;
    return `${hh}h ${mm}m`;
  }

  const onSelect = async (itinerary) => {
    let journeyNo = flightSearchParams.journeyNo;
    let selectedItineraries = flightSearchParams.selectedItineraries ?? [];


    if (
      flightSearchParams.journeyType === "ow" ||
      journeyNo === flightSearchParams.journeyRoutes.length
    ) {
      const flightsPreorderResult = await post('/flights/preorder', {
        flightSearchParams: flightSearchParams,
        selectedItineraries: [...selectedItineraries, itinerary],
        }
      );
      if (flightsPreorderResult == null) {
        toast.error("Something went wrong, pleate try again");
        return;
      }

      navigate("/flight-checkout", {
        state: { flightSearchParams, flightsPreorderResult},
      });
    } else {
      let nextJourneyNo = journeyNo + 1;

      navigate(buildFlightsUrl(flightSearchParams, nextJourneyNo), {
        state: { selectedItineraries: [...selectedItineraries, itinerary]},
      });
    }
  };

  if (isLoading) {
    return;
  }

  let hasFlights =
    !!flightSearchResult &&
    !!flightSearchResult?.itineraryGroups &&
    !!flightSearchResult.itineraryGroups.length > 0;

  return (
    <>
      <div className="flights-content">
        <div className="heading-wrap">
          {/* <h2>{flights?.length || 0} Flights found</h2> */}

          {flightSearchParams.journeyType === "rt" && !!hasFlights &&
            ((flightSearchParams.journeyNo === 1 &&
              !!flightsLocationSelections?.[0]?.to?.cityName) ||
              (flightSearchParams.journeyNo > 1 &&
                !!flightsLocationSelections?.[0]?.from?.cityName)) && (
              <div className="flight-title-section">
                <div className="title-text">
                  {`${flightSearchParams.journeyNo}: Select flight to ${
                    flightSearchParams.journeyNo === 1
                      ? flightsLocationSelections?.[0]?.to?.cityName
                      : flightsLocationSelections?.[0]?.from?.cityName
                  } `}
                </div>
                <div className="spacer" />
              </div>
            )}

          {flightSearchParams.journey === "multi" && !!hasFlights &&
            !!flightsLocationSelections?.[flightSearchParams.journeyNo - 1]?.to
              ?.cityName && (
              <div className="flight-title-section">
                <div className="title-text">
                  {`${flightSearchParams.journeyNo}: Select flight to ${
                    flightsLocationSelections?.[
                      flightSearchParams.journeyNo - 1
                    ]?.to?.cityName
                  } `}
                </div>
                <div className="spacer" />
              </div>
            )}

          {!!flightSearchResult &&
            !!flightSearchResult?.itineraryGroups &&
            !!flightSearchResult.itineraryGroups.length > 0 &&
            !!flightSearchResult.sortByConfigs && (
              <div className="select-sort-by">
                <select
                  name="sort_by"
                  id="sort-by"
                  onChange={(e) => sortBy(e.target.value)}
                  value={flightSearchParams.sortBy || ""}
                >
                  {[...(flightSearchResult.sortByConfigs || [])].map(
                    (config) => {
                      return (
                        <option value={config.type} key={config.type}>
                          Sort by: {config.name}
                        </option>
                      );
                    }
                  )}
                </select>
              </div>
            )}

          <button id="toggle_hide" onClick={onToggle}>
            <img src="/images/icons/sort.svg" alt="filters" />
          </button>
        </div>
        {(flightSearchResult.itineraryGroups || []).map(
          (itineraryGroup, index) => {
            return (
              <div key={index}>
                {itineraryGroup?.name && itineraryGroup.name.trim() !== "" && (
                  <>
                    <div className="group-name">{itineraryGroup.name}</div>

                    <div style={{ height: 16 }} />
                  </>
                )}

                <div>
                  {(itineraryGroup.itineraries || []).map(
                    (itinerary, index) => {
                      return (itinerary.journeys || []).map(
                        (journey, index) => {
                          const firstFlight = journey.flights?.[0];
                          const lastFlight =
                            journey.flights?.[journey.flights.length - 1];

                          const seatsLeft =
                            journey.seatsAvailable != null &&
                            journey.seatsAvailable > 0
                              ? journey.seatsAvailable + 1
                              : null;

                          return (
                            <div className="flight-item-box" key={index}>
                              {/* <div className="badges">
                                  <div className="badge-cheap">Cheapest</div>
                                  <div className="badge-light">
                                    <img
                                      src="/images/icons/carry.svg"
                                      alt="icon"
                                    />{" "}
                                    Carry-on {journey?.flights[0]?.baggage}{" "}
                                    baggage included
                                  </div>
                                </div> */}

                              <div className="badges">
                                <div
                                  className={
                                    journey.cabinName === "First" ||
                                    journey.cabinName === "Bussiness"
                                      ? "badge-light"
                                      : "badge-green"
                                  }
                                  style={{
                                    fontSize: "13px",
                                  }}
                                >
                                  {journey.cabinName}
                                </div>

                                {!!seatsLeft &&
                                  seatsLeft >= 2 &&
                                  seatsLeft <= 9 && (
                                    <div
                                      style={{
                                        marginLeft: "auto",
                                        marginRight: "25px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        color: "#b23a3a",
                                      }}
                                    >
                                      {`<${seatsLeft} left`}
                                    </div>
                                  )}
                              </div>

                              <div className="row justify-content-between align-items-center">
                                {/* Airline */}
                                <div className="col-md-3 py-0">
                                  <div className="air-line">
                                    <img
                                      src={
                                        firstFlight?.airline?.brandmarkUrl ||
                                        firstFlight?.airline?.logo ||
                                        "/images/icons/flight-icon.svg"
                                      }
                                      alt={
                                        firstFlight?.airline?.name || "airline"
                                      }
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        objectFit: "contain",
                                      }}
                                    />
                                    <div className="air-line__details">
                                      {journey.flights.map((flight, index) => (
                                        <p key={`${flight?.flightNo}-${index}`}>
                                          <strong>
                                            {flight.airline?.name || flight.airline?.iata || "Airline"}
                                          </strong>
                                          <span>{flight?.flightNo}</span>
                                        </p>
                                      ))}
                                    </div>
                                    {/* <p>
                                        {firstFlight?.airline?.name},{" "}
                                        {firstFlight?.carrier?.equipment?.code}
                                      </p> */}
                                  </div>
                                </div>

                                {/* Flight Details */}
                                <div className="col-md-4 py-0">
                                  <div className="flight-row">
                                    <div className="title">
                                      <div className="time-wrapper">
                                        <h5>
                                          {formatTime(journey?.departDateTime)}
                                        </h5>

                                        {journey?.departDayCount > 0 && (
                                          <span className="day-badge">
                                            +{journey?.departDayCount}
                                          </span>
                                        )}
                                      </div>

                                      <p>
                                        {!!firstFlight?.departure
                                          ?.airportName ? (
                                          <Tooltip
                                            color="#fff"
                                            placement="bottom"
                                            title={`${firstFlight?.departure?.airportName} ${firstFlight?.departure?.terminal}`}
                                          >{`${firstFlight?.departure?.airport} ${firstFlight?.departure?.terminal}`}</Tooltip>
                                        ) : (
                                          `${firstFlight?.departure?.airport} ${firstFlight?.departure?.terminal}`
                                        )}
                                      </p>
                                    </div>

                                    <div className="time-duration">
                                      <p>{formatDuration(journey?.duration)}</p>
                                      <img
                                        src="/images/icons/flight-row.svg"
                                        alt="flight-row"
                                      />
                                      {journey.stopCount > 0 && (
                                        <p>
                                          {`${journey.stopCount} `}
                                          stop
                                          {journey.stopCount > 1 ? "s" : ""}
                                        </p>
                                      )}
                                    </div>

                                    <div className="title to">
                                      <div className="time-wrapper">
                                        <h5>
                                          {formatTime(journey?.arriveDateTime)}
                                        </h5>

                                        {journey?.arriveDayCount > 0 && (
                                          <span className="day-badge">
                                            +{journey?.arriveDayCount}
                                          </span>
                                        )}
                                      </div>
                                      <p>
                                        {!!lastFlight?.arrival?.airportName ? (
                                          <Tooltip
                                            color="#fff"
                                            placement="bottom"
                                            title={`${lastFlight?.arrival?.airportName} ${lastFlight?.arrival?.terminal}`}
                                          >{`${lastFlight?.arrival?.airport} ${lastFlight?.arrival?.terminal}`}</Tooltip>
                                        ) : (
                                          `${lastFlight?.arrival?.airport} ${lastFlight?.arrival?.terminal}`
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* Price */}
                                <div className="col-md-4 py-0">
                                  <div className="price-wrap">
                                    <div className="price">
                                      <h2>
                                        {itinerary.price.currency}{" "}
                                        {itinerary.price.displayTotal}
                                      </h2>
                                      {/* <p>Return</p> */}
                                    </div>
                                    <Link
                                      to="/flight-checkout"
                                      className="flight-select"
                                      // state={{ flight, passenger }}
                                      onClick={(e) => {
                                        e.preventDefault();

                                        onSelect(itinerary);
                                      }}
                                    >
                                      Select
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      );
                    }
                  )}
                </div>
              </div>
            );
          }
        )}
      </div>
    </>
  );
};

export default FlightsContent;
